import { getHttpClientAsLastParam } from 'ContentData/helpers/apiHelpers';

/**
 * GET /gotowebinar/v1/settings
 *
 * @returns {Promise} request for current webinar settings
 */
export function fetchSettings(query, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('gotowebinar/v1/settings');
}

/**
 * GET /forms/v2/forms/gotowebinar-eligible
 *
 * @returns {Promise} request for eligible form GUIDS
 */
export function fetchEligibleForms(...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('forms/v2/forms/gotowebinar-eligible');
}

/**
 * GET /gotowebinar/v1/webinars/future
 *
 * @returns {Promise} request for all future webinars
 */
export function fetchFutureWebinars(query, ...rest) {
  const httpClient = getHttpClientAsLastParam(rest);
  return httpClient.get('gotowebinar/v1/webinars/future?includeOnDemand=true');
}